import { useTranslations } from 'next-intl'

import { formatPhoneNumber } from '@/shared/lib'
import { Button, Dialog, Description } from '@/shared/ui'

type Props = {
  title: string
  name: string
  phoneNumber: string
}

export const Call = ({ title, name, phoneNumber }: Props) => {
  const t = useTranslations('guest_lease_list')

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <Button
          variant="outline"
          size="small"
          color="primary"
          shape="pill"
          className="w-[75px]"
        >
          {t('unit.button.call')}
        </Button>
      </Dialog.Trigger>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>{title}</Dialog.Title>
        </Dialog.Header>
        <Description.List className="space-y-4">
          <Description.Item>
            <Description.ItemLabel className="typo-body1" normal>
              {t('dialog.host_contact.label.name')}
            </Description.ItemLabel>
            <Description.ItemValue className="typo-body1-reading" normal>
              {name}
            </Description.ItemValue>
          </Description.Item>
          <Description.Item>
            <Description.ItemLabel className="typo-body1" normal>
              {t('dialog.host_contact.label.phone')}
            </Description.ItemLabel>
            <Description.ItemValue className="typo-body1-reading" normal>
              {formatPhoneNumber(phoneNumber)}
            </Description.ItemValue>
          </Description.Item>
        </Description.List>
        <Dialog.Footer>
          <Dialog.Close asChild>
            <Button size="large" color="primary">
              {t('dialog.host_contact.button.confirm')}
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  )
}
